module.exports = __webpack_public_path__ + "assets/img/jr_img1.2d222234.png";